import { FunctionComponent } from 'react';
import { Layout as AdminLayout, LayoutProps } from 'react-admin';
import { DialogProvider } from 'src/Components/DialogProvider';

export const Layout: FunctionComponent<LayoutProps> = (props) => (
  <DialogProvider>
    <AdminLayout {...props} />
  </DialogProvider>
);
